import { Link } from "react-router-dom";

const SocialLogin = ({
  title = "or Sign In with",
  providers = [
    { id: 1, name: "Facebook", icon: "/image/facebook-f.svg", bgColor: "black" },
    { id: 2, name: "Google", icon: "/image/google.svg", bgColor: "white" }
  ],
  onSocialLogin
}) => {
  return (
    <div className="or-option text-center">
      <span className="d-block position-relative">{title}</span>
      <div className="d-flex align-items-center justify-content-center gap-3">
        {providers.map((provider) => (
          <Link key={provider.id} to="#" className={`option-signin ${provider.bgColor} d-flex align-items-center justify-content-center gap-2`} onClick={() => onSocialLogin(provider.name.toLowerCase())}>
            <img src={provider.icon} alt={provider.name} />
            {provider.name}
          </Link>
        ))}
      </div>
    </div>
  );
};

export default SocialLogin;